export default __webpack_public_path__ + "static/media/compra_mercado.5a27c50b.svg";